import React from "react";
import { observer } from "mobx-react-lite";
import cx from "classnames";
import { Hooks } from "@xt/xtbase";
//import store from "store";
import styles from "./index.module.scss";
import { Modal } from "antd";
import CopyText from "@/components/Xt/CopyText";
interface SecretProps extends BaseCompProps {
  attr?: any;
  open?: boolean;
  title?: string;
  keyMap?: { accessKey: string; secretKey: string };
  closeSecret?(bool: boolean): void;
}
const { useTranslation } = Hooks;
const Secret: React.FC<SecretProps> = ({ className, open, title, keyMap, closeSecret }) => {
  const t = useTranslation();
  //const {isLogin} = store.user;
  return (
    <Modal className={styles["secert_modal"]} open={open} title={title} width={800} footer={null} onCancel={() => closeSecret?.(false)}>
      <div className={styles["secret_content"]}>
        <div className={styles["col-md-12"]}>
          <div className={styles["secret_c_childrens"]}>
            <div className={styles["secret_list"]}>
              <p className={styles["secret_title"]}>{t("account.PublicKey")}（AccessKey）</p>
              <div className={styles["secre_chil_c"]}>
                <div className={styles["sec_p"]}>{keyMap?.accessKey}</div>
                <CopyText className={cx(styles["copy_btn"], "ant-btn")} text={keyMap?.accessKey || " "} color="#000">
                  {(icon) => (
                    <>
                      {icon}
                      <span style={{ marginLeft: "8px" }}>{t("account.Copy")}</span>
                    </>
                  )}
                </CopyText>
              </div>
            </div>
            <div className={styles["secret_list"]}>
              <p className={styles["secret_title"]}>{t("account.PrivateKey")}（SecretKey）</p>
              <div className={styles["secre_chil_c"]}>
                <div className={styles["sec_p"]}>{keyMap?.secretKey}</div>
                <CopyText className={cx(styles["copy_btn"], "ant-btn")} text={keyMap?.secretKey || " "} color="#fff">
                  {(icon) => (
                    <>
                      {icon}
                      <span style={{ marginLeft: "8px" }}>{t("account.Copy")}</span>
                    </>
                  )}
                </CopyText>
              </div>
            </div>

            <div className={styles["import_tip"]}>
              <b>{t("account.ImportantNotice")}</b>
              {t("account.MakeSureCopied")}
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};
Secret.defaultProps = {
  keyMap: { accessKey: "", secretKey: "" },
};
export default observer(Secret);
